import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { calculationService } from '../utils/api/calculationService';
import { useCalculationsStore } from '../store/calculations';

export function useCopyCalculation(getCalculationId: () => number) {
  const isLoading = ref(false);

  const calculationsStore = useCalculationsStore();

  const toast = useToast();

  async function copyCalculation() {
    const calculationId = getCalculationId();

    try {
      isLoading.value = true;

      const copy = await calculationService.copyCalculation(calculationId);

      if (copy) {
        calculationsStore.appendCalculationChild(calculationId, copy);

        toast.add({
          severity: 'success',
          summary: 'Utworzono kopię kalkulacji',
          life: 3000,
        });
      }
    } catch (error) {
      console.log(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas kopiowania kalkulacji',
        life: 3000,
      });
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    copyCalculation,
  };
}
